(function(){
  function initSticky(){
    var ann = document.querySelector('.announcement-bar-section');
    var hdr = document.querySelector('#shopify-section-zonafit_header');
    var nav = document.querySelector('#shopify-section-zona-fit-navmenu');
    if(!hdr) return;
    if(window.innerWidth >= 750){
      var annH = 0;
      if(ann){ ann.style.cssText='position:sticky;top:0;z-index:502'; annH=ann.offsetHeight; }
      hdr.style.cssText='position:sticky;top:'+annH+'px;z-index:501';
      if(nav){ nav.style.cssText='position:sticky;top:'+(annH+hdr.offsetHeight)+'px;z-index:500'; }
    } else {
      if(ann) ann.style.cssText='';
      hdr.style.cssText='position:sticky;top:0;z-index:500';
      if(nav) nav.style.cssText='';
    }
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', initSticky);
  } else {
    initSticky();
  }
  window.addEventListener('resize', initSticky);
})();
